import React from 'react';
import { ClipboardCheckIcon, GraduationCapIcon, UsersRoundIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const items = [{
  icon: ClipboardCheckIcon,
  title: 'Patient and protocol fit',
  desc: 'Compare the technology against the conditions, treatment goals, and visit flow your practice actually supports.'
}, {
  icon: UsersRoundIcon,
  title: 'Workflow inside the practice',
  desc: 'Consider room setup, staff time, treatment sequence, training needs, and how the modality fits into daily care.'
}, {
  icon: GraduationCapIcon,
  title: 'A rollout doctors can use',
  desc: 'Move from equipment selection to training, patient education, and confident implementation instead of letting a device sit underused.'
}];
export function ProductDepth() {
  return <section className="w-full bg-white py-20 sm:py-24" data-id="element-735" data-mp="33mvs2ygu3xwj">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-736" data-mp="38lyyam8jwa63">
        <SectionHeading eyebrow="BEFORE YOU INVEST" title="Know what the spec sheet won’t tell you" description="Manufacturer specs matter, but they are only part of the decision. JAG helps practices compare how a modality fits patient demand, treatment flow, staff training, space, and long-term use in the office." align="center" data-id="element-737" data-mp="38ol7srf04zqy" />
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-738" data-mp="2t0jmteelko8g">
          {items.map(item => {
          const Icon = item.icon;
          return <div key={item.title} className="rounded-2xl border border-slate-200 bg-slate-50 p-7" data-id="element-739" data-mp="2k91714lkcafw">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-teal/10 text-teal" data-id="element-740" data-mp="2fa6kbrkh61qi">
                  <Icon className="h-5 w-5" data-id="element-741" data-mp="2a8h4lymb4zw3" />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-navy" data-id="element-742" data-mp="25a789koujt8w">
                  {item.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-charcoal/70" data-id="element-743" data-mp="21c02tlzu2ed0">
                  {item.desc}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}